import { PageAction } from './../models/page-config';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-dynamic-form-dialog',
  templateUrl: './dynamic-form-dialog.component.html',
  styleUrls: ['./dynamic-form-dialog.component.scss']
})
export class DynamicFormDialogComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicFormComponent;

  apiCallInProgress: boolean = false;

  constructor(
    private baseService: BaseService,
    private dialogRef: MatDialogRef<DynamicFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      formFields: any[],
      initialFormValue: any,
      dialogTitle: string,
      dialogText: string,
      action: PageAction,
      fxLayout: string,
      fxLayoutAlign: string,
      fxLayoutGap: string,
      additionalData: any,
      buttons: any[],
    }) { }

  ngOnInit(): void {
  }

  get formValid(): boolean {
    if (!this.dynamicFormComponent) {
      return true;
    }

    // If all form fields are readOnly = true, return true
    let allReadOnly = true;
    this.data.formFields.forEach(formField => {
      if (formField.readOnly === false) {
        allReadOnly = false;
      }
    });
    if (allReadOnly === true) return true;

    return this.dynamicFormComponent.valid;
  }

  submit(buttonValue: any) {
    this.apiCallInProgress = true;
    this.disableForm();

    let body = this.dynamicFormComponent ? this.dynamicFormComponent.value : this.data.initialFormValue;
    if (buttonValue) {
      body = Object.assign(body, { buttonValue: buttonValue });
    }

    this.baseService.executeCommand(this.data.action.actionData.apiFunction, body)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close(response.data);
        }
        this.apiCallInProgress = false;
        this.reenableForm();
      });
  }

  disableForm() {
    this.dynamicFormComponent?.form?.disable();
  }

  reenableForm() {
    if (this.data.formFields) {
      this.data.formFields.forEach(formField => {
        if (formField.readOnly === false) {
          this.dynamicFormComponent?.form?.controls[formField.name]?.enable();
        }
      });
    }
  }
}
